import React, { useState, useEffect } from "react";
import ReactSelect from 'react-select';
import axios from "axios";

function ScrapperBody({ activeBody }) {
  const host = "https://crmdust2.com/api/proxy";

  const [providers, setProviders] = useState([]);
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [opcionesSeleccionadas, setOpcionesSeleccionadas] = useState([]);
  const [showModalAddBrand, setShowModalAddBrand] = useState(false);
  const [newBrandName, setNewBrandName] = useState('');
  const [bodyActive, setBodyActive] = useState('brands');

  const [selectedProvider, setSelectedProvider] = useState('');
  const [selectedType, setSelectedType] = useState('');
  const [infoPost, setInfoPost] = useState('');

  const fetchBrands = async ( )=>{

    return axios.get(`${host}/brands`);
  }
  useEffect(() => {
    const fetchData = async () => {
      try {
        const providersResponse = await axios.get(`${host}/proveedor`);
        setProviders(providersResponse.data);
        const brandsResponse = await fetchBrands();
        const categoriesResponse = await axios.get(`${host}/categories`);
        setBrands(brandsResponse.data);
        setCategories(categoriesResponse.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleTypeChange = (event) => {
    setBodyActive(event.target.value);
    setSelectedType(event.target.value);
  };

  const handleSelectChange = (selectedOptions) => {
    setOpcionesSeleccionadas(selectedOptions.map(option => option.value));
  };



  return (
    <div className={`Content__scraperForm--bodies-body ${activeBody === "scrapper" ? "activeBody" : ""}`}>
      <form onSubmit={handleSubmit}>
        <div className="Content__scraperForm--inputContainer">
          <label htmlFor="provider">Proveedor / Pagina Web</label>
          <select name="web" id="web" value={selectedProvider} onChange={(ev)=> setSelectedProvider(ev.target.value)}>
          <option value="" disabled>Selecciona un proveedor</option>
            {providers.map((provider) => (
              <option key={provider.id} value={provider.name}>
                {provider.name}
              </option>
            ))}
          </select>
        </div>
        <div className="Content__scraperForm--inputContainer">
          <label htmlFor="type">Tipo De Scrap</label>
          <select name="type" id="type" onChange={handleTypeChange} value={selectedType}>
          <option value="" disabled>Selecciona un tipo de scapp</option>

            <option value="brands">Busqueda</option>
            <option value="categories">Categorias</option>
            <option value="links">Links</option>
          </select>
        </div>
        <div className={`Content__scraperForm--inputContainer bodyType ${bodyActive === "brands" || bodyActive === "" ? "bodyTypeActive" : ""}`}>
          <label htmlFor="brands">Marcas 
            <button type="button" onClick={() => setShowModalAddBrand(true)}>Agregar Marca</button>
          </label>
          
          <ReactSelect
            isMulti
            options={brands.map((brand) => ({ label: brand.name, value: brand.name }))}
            className="basic-multi-select"
            classNamePrefix="select"
            onChange={handleSelectChange}
            name="brands"
            id="brands"
            value={brands.filter(brand => opcionesSeleccionadas.includes(brand.name)).map((brand) => ({ label: brand.name, value: brand.name }))}
          />
        </div>
        <div className={`Content__scraperForm--inputContainer bodyType ${bodyActive === "categories" ? "bodyTypeActive" : ""}`}>
          <label htmlFor="categories">Categorias</label>
          <select name="categories" id="categories">
            <option value="" disabled>Selecciona la Categoria</option>
            <option>Selecciona la categoria</option>
            {categories.map((category, index) => (
              <option key={index} value={category.name}>
                {category.name}
              </option>
            ))}
          </select>
        </div>
        <div className={`Content__scraperForm--inputContainer bodyType ${bodyActive === "links" ? "bodyTypeActive" : ""}`}>
          <label htmlFor="links">Links</label>
          <input
            name="links"
            id="links"
            rows="6"
            placeholder="Ingresa tus URL como arreglo de textos [ 'href','href' ]"
          />
        </div>
        <div className="Content__scraperForm--inputTwoCols">
          <div className="Content__scraperForm--inputContainer checkboxInput">
            <input type="checkbox" name="emailV" id="emailV" />
            <label htmlFor="emailV">Enviar por Correo</label>
          </div>
          <div className="Content__scraperForm--inputContainer">
            <label htmlFor="email">Correo</label>
            <input name="email" id="email" />
          </div>
        </div>
        <div className="Content__scraperForm--sendButton">
          <button type="submit">Enviar</button>
        </div>
      </form>
      <div className={`Content__scrapperForm--addBrand ${showModalAddBrand === true ? "activeModalBrand" : ""}`}>

        <div className="Content__scrapperForm--addBrand-container">
              <form method="post" onSubmit={addBrand}>
                <div className="Content__scraperForm--inputContainer">
                  <label htmlFor="addBrand">Agregar Marca</label>
                  <input type="text" name="addBrand" value={newBrandName} id="addBrand" onInput={(event) => setNewBrandName(event.target.value)} />
                </div>
                <div className="Content__scrapperForm--addBrand-button">
                  <button onClick={() => setShowModalAddBrand(false)}>Cancelar</button>
                  <button>Agregar</button>
                </div>
              </form>
        </div>
      </div>
      {infoPost && (
        <h3 style={{textAlign: "center"}}>{infoPost}</h3>
      )}
    </div>
  );

  async function handleSubmit(ev) {
    ev.preventDefault();
    const web = ev.target.web.value;
    const type = ev.target.type.value;
    const links = ev.target.links.value;
    const categories = ev.target.categories.value;
    const email = ev.target.email.value;
    const emailV = ev.target.emailV.checked;
    let value;
    let valueType = type;
    switch (type) {
      case 'brands':
        value = opcionesSeleccionadas; valueType = 'search'; break;
      case 'links':
        value = links; break;
      case 'categories':
        value = [categories]; break;
      default: break;
    }
    const data = {
      name: web,
      configurations: {
        type: valueType,
        value,
        isEmail: emailV,
        email,
      }
    };
    console.log(data);
    try {
      const response = await axios.post(host + '/scrape/providerTesting', data);
      console.log(response);
      setInfoPost(response.data.message);
    } catch (error) {
      console.error("Error al enviar los datos:", error)
    }
  }

  async function addBrand (ev) {
    ev.preventDefault();

    await axios.post(`${host}/brand`, {name: ev.target.addBrand.value});
    setShowModalAddBrand(false);
    setNewBrandName(''); 
    fetchBrands();
  }
  
}

export { ScrapperBody };
